import { lazy } from 'react';
import AdminLayout from 'src/layouts/AdminLayout';
import { RouteI } from 'src/models/router';
import { RoutePath } from 'src/router/routePath';

const OptionToolsPage = lazy(() => import('../pages/OptionTools/Index'));
const OptionToolAuthorizePage = lazy(
  () => import('../pages/OptionTools/Authorize'),
);

export const createOptionToolRoutes = (
  optionToolsEnabled: boolean,
): RouteI[] =>
  optionToolsEnabled
    ? [
        {
          path: RoutePath.OPTION_TOOLS,
          Component: OptionToolsPage,
          Layout: <AdminLayout />,
          isPrivate: true,
        },
        {
          path: RoutePath.OPTION_TOOLS_AUTHORIZE,
          Component: OptionToolAuthorizePage,
          isPrivate: true,
        },
      ]
    : [];
